// TODO: Change component and file name
// the name of this component is not correct it all
// it bears no resemblance to what this component actually is.
// This is not a generic popover component.
// This is a dropdown menu in the calendar page with some options related to the menu so it should be named accordingly.

import { Popover, Transition } from "@headlessui/react";
import {
  DotsVerticalIcon,
  RefreshIcon,
  ChevronLeftIcon,
  PencilAltIcon,
} from "@heroicons/react/solid";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { TableIcon } from "@heroicons/react/outline";
type PopoverComponentProps = {
  tabCalendarNumber: number;
};
export default function PopoverComponent(props: PopoverComponentProps) {
  const { tabCalendarNumber } = props;
  const LocalBasePath = "page.tutor.dashboard.schedule";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { currentUser, userType }: any = useAuth();

  return (
    <div className="w-[296px] top-16">
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button className="inline-flex items-center px-3 py-2 bg-transparent border-gray-200 rounded-none ltr:border-l rtl:border-r focus:outline-none">
              {" "}
              <DotsVerticalIcon
                className="w-5 h-5 text-gray-400 transition duration-150 ease-in-out"
                aria-hidden="true"
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-50 w-screen max-w-sm px-4 mt-3  rtl:left-[85%] ltr:right-[85%] rtl:md:-right-[120%] rtl:lg:-right-full   ltr:lg:right-1/2   ltr:md:right-[30%]   transform  rtl:md:-translate-x-3.5 ltr:md:-translate-x-1/2  sm:px-0 lg:w-[296px]">
                <div className="overflow-hidden  rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative   grid grid-cols-1 gap-[10px] bg-white p-6">
                    {!currentUser?.hasRecitationSchedule &&
                      userType === "student" && (
                        <Link
                          to={`/student/proposed-schedule`}
                          className="flex flex-row items-center justify-between w-full pb-[10px] text-sm text-gray-500 border-b border-ray-200"
                        >
                          <div className="flex flex-row gap-2">
                            <TableIcon className="w-6 h-6" />
                            <p>{t("setCalendar")}</p>
                          </div>
                          <ChevronLeftIcon className="w-5 h-5 ltr:rotate-180" />
                        </Link>
                      )}
                    {(!!currentUser?.hasRecitationSchedule ||
                      userType !== "student") && (
                      <Link
                        to={`/${userType}/dashboard/weekly-schedule/update`}
                        className="flex flex-row items-center justify-between w-full pb-[10px] text-sm text-gray-500 border-b border-ray-200"
                      >
                        <div className="flex flex-row gap-2">
                          <PencilAltIcon className="w-6 h-6" />
                          <p className="">{t("changeSchedule")}</p>
                        </div>
                        <ChevronLeftIcon className="w-5 h-5 ltr:rotate-180" />
                      </Link>
                    )}
                    <Link
                      to={`/${userType}/dashboard/personal-data?tab=${tabCalendarNumber}`}
                      className="flex flex-row items-center justify-between w-full pb-[10px] text-sm text-gray-500"
                    >
                      <div className="flex flex-row gap-2">
                        <RefreshIcon className="w-6 h-6" />
                        <p>{t("syncCalendar")}</p>
                      </div>
                      <ChevronLeftIcon className="w-5 h-5 ltr:rotate-180" />
                    </Link>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}

function IconOne() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#FFEDD5" />
      <path
        d="M24 11L35.2583 17.5V30.5L24 37L12.7417 30.5V17.5L24 11Z"
        stroke="#FB923C"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7417 19.8094V28.1906L24 32.3812L31.2584 28.1906V19.8094L24 15.6188L16.7417 19.8094Z"
        stroke="#FDBA74"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7417 22.1196V25.882L24 27.7632L27.2584 25.882V22.1196L24 20.2384L20.7417 22.1196Z"
        stroke="#FDBA74"
        strokeWidth="2"
      />
    </svg>
  );
}

function IconTwo() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#FFEDD5" />
      <path
        d="M28.0413 20L23.9998 13L19.9585 20M32.0828 27.0001L36.1242 34H28.0415M19.9585 34H11.8755L15.9171 27"
        stroke="#FB923C"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.804 30H29.1963L24.0001 21L18.804 30Z"
        stroke="#FDBA74"
        strokeWidth="2"
      />
    </svg>
  );
}

function IconThree() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#FFEDD5" />
      <rect x="13" y="32" width="2" height="4" fill="#FDBA74" />
      <rect x="17" y="28" width="2" height="8" fill="#FDBA74" />
      <rect x="21" y="24" width="2" height="12" fill="#FDBA74" />
      <rect x="25" y="20" width="2" height="16" fill="#FDBA74" />
      <rect x="29" y="16" width="2" height="20" fill="#FB923C" />
      <rect x="33" y="12" width="2" height="24" fill="#FB923C" />
    </svg>
  );
}
